import { render, staticRenderFns } from "./InstellingenBase.vue?vue&type=template&id=dc35eaa4&"
import script from "./InstellingenBase.vue?vue&type=script&lang=js&"
export * from "./InstellingenBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports